import { render, staticRenderFns } from "./ActivePlans.vue?vue&type=template&id=dc25b8e2"
import script from "./ActivePlans.vue?vue&type=script&lang=js"
export * from "./ActivePlans.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports